// 261012 학원·교회 회원 첫 화면(기관 템플릿) — 순수 함수만(node 테스트 대상). 화면·API 는 OrgHome.vue / ServiceLanding.vue / QrLanding.vue.
// 기획서 C:/Temp/jump-org-home-261012-docs/specs/2026-10-12-org-home-template-design.md
const CACHE_PREFIX = 'gp-org-home:'; // 마지막 판정(앱 시작 깜빡임 방지) — 회원 번호별
const ASK_PREFIX = 'gp-org-home-ask:'; // 저장 뒤 묻기에 [아니요] — 회원 번호·현판 코드별

const safe = fn => { try { return fn(); } catch (_) { return null; } }; // 사생활 보호 모드 등 저장소가 막혀도 화면은 그린다

export const readOrgHomeCache = (storage, userNo) => {
  if (!userNo) return null;
  const v = safe(() => JSON.parse(storage.getItem(CACHE_PREFIX + userNo) || 'null'));
  return v && (v.mode === 'ORG' || v.mode === 'GANPANON') ? v : null;
};

export const writeOrgHomeCache = (storage, userNo, home) => {
  if (userNo && home) safe(() => storage.setItem(CACHE_PREFIX + userNo, JSON.stringify(home)));
};

export const askedOrgHome = (storage, userNo, qrCode) => !!safe(() => storage.getItem(`${ASK_PREFIX}${userNo}:${qrCode}`));

export const markAskedOrgHome = (storage, userNo, qrCode) => {
  if (userNo && qrCode) safe(() => storage.setItem(`${ASK_PREFIX}${userNo}:${qrCode}`, '1'));
};

// 261102 확인 208 문제 #15 — 회원 홈에서 고른 화면(간판ON 둘러보기 org · 내 차 관리판 보기 orgPk · 주차판 회원의 간판ON 둘러보기 pk)을
//   그 기록 칸(history.state)에 회원 번호와 함께 적어 두고, '뒤로'로 그 칸에 돌아왔을 때만 되살린다. 아래 탭 '홈'·주소·앱 새로 열기는
//   새 기록 칸이라 적힌 게 없어 회원 첫 화면(261012·261020 그대로). 저장소에는 두지 않는다. 다른 회원이 적은 것은 버린다.
const HOME_PICK = 'gpHomePick';
export const readHomePick = (state, userNo) => {
  const p = state && state[HOME_PICK];
  return p && userNo && p.u === userNo ? { org: !!p.org, orgPk: !!p.orgPk, pk: !!p.pk } : { org: false, orgPk: false, pk: false };
};
/** vue-router 칸 값(back·current·forward·position·scroll)은 그대로 두고 고른 화면만 더한 새 칸 — history.replaceState 에 넘긴다 */
export const withHomePick = (state, userNo, pick) => ({ ...(state || {}), [HOME_PICK]: { u: userNo || null, org: !!pick.org, orgPk: !!pick.orgPk, pk: !!pick.pk } });

/** 로그아웃 — 이 기기의 기관 템플릿 기억을 모두 지운다(rules/25 §1). 다른 기능 키는 건드리지 않는다. */
export const clearOrgHomeStorage = storage => {
  const keys = safe(() => Array.from({ length: storage.length }, (_, i) => storage.key(i))) || [];
  keys.filter(k => k && (k.startsWith(CACHE_PREFIX) || k.startsWith(ASK_PREFIX))).forEach(k => safe(() => storage.removeItem(k)));
};

// 학원 템플릿 바로가기 — 학부모에게 쓸모 있는 칸만, 이 순서로. 수강료·레벨테스트·체험 같은 처음 온 손님용 칸은 '현판 전체 보기' 뒤로.
export const ACADEMY_SHORTCUTS = ['TIMETABLE', 'SHUTTLE', 'STAFF_INTRO', 'ACADEMY_EVENT', 'CONSULT', 'PHONE', 'MAP', 'OWNER_NOTE'];
// 교회 템플릿 — 10/1 성도 홈 CHURCH_HOME_SKIP 과 같은 칸 + 학원비 결제를 뺀 나머지를 교회가 정한 순서대로.
export const CHURCH_SKIP = ['NOTICE', 'GALLERY', 'ONLINE_MEMORIAL', 'HOURS', 'COMPANY_INTRO', 'SAVE_BIZ', 'GANPANON', 'DAILY_VERSE', 'DOORBELL', 'TUITION_PAY'];

/** 템플릿 바로가기 칸. tiles = GET /api/user/qr/home 의 org.tiles, removed = QR_TILE_REMOVED, flagOff = 스위치 꺼진 칸 판정. */
export const orgShortcuts = (kind, tiles, { removed = [], flagOff = () => false } = {}) => {
  const usable = (tiles || []).filter(t => t && !removed.includes(t.platform) && !flagOff(t));
  if (kind === 'ACADEMY') return ACADEMY_SHORTCUTS.map(p => usable.find(t => t.platform === p)).filter(Boolean);
  if (kind === 'CHURCH') return usable.filter(t => !CHURCH_SKIP.includes(t.platform)).sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
  return [];
};
